export default __webpack_public_path__ + "static/media/InstallKubernetesAgent_pre2047.d932b1f2.md";